













































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import BuscaDeProduto from '@/components/produto/BuscaDeProduto.vue'
import type { FormProdutoSimplesFilho, Loja } from '@/models'

@Component({
	components: { BuscaDeProduto },
})
export default class DialogoDeBuscarRegraBaseFiscal extends Vue {
	@Prop({ type: Boolean, default: false }) mostra!: boolean
	@Prop({ type: Boolean, default: false }) carregando!: boolean
	@Prop({ required: true }) loja!: Loja

	produtoSelecionado: FormProdutoSimplesFilho | null = null

	get podeConfirmar(): boolean {
		return !!this.produtoSelecionado?.id
	}

	@Watch('mostra')
	onAbrirOuFechar(aberto: boolean) {
		if (aberto) {
			this.produtoSelecionado = null
			this.$nextTick(() => {
				const busca = this.$refs.buscaProduto as BuscaDeProduto | undefined
				busca?.focus()
			})
		}
	}

	@Watch('produtoSelecionado')
	onProdutoEncontrado(produto: FormProdutoSimplesFilho | null) {
		if (!produto?.id) return
		this.$nextTick(() => {
			const busca = this.$refs.buscaProduto as BuscaDeProduto | undefined
			busca?.blur()
		})
	}

	fechar() {
		this.$emit('update:mostra', false)
	}

	confirmar() {
		if (!this.produtoSelecionado?.id || this.carregando) return
		this.$emit('confirmar', this.produtoSelecionado)
	}
}
